import axios from 'axios'

import { Toast } from 'vant';
import { baseUrl } from '@/config/index.js'
// 测试URL
axios.defaults.baseURL = baseUrl;
// 生产URL
// axios.defaults.baseURL = "http://www.introtec.cn/api/jeecg-boot/api/intro";

// 创建axios实例
let http = axios.create({
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    timeout: 300000
})


http.interceptors.request.use(config => {
    return config
}, error => {
    return Promise.reject(error)
})

http.interceptors.response.use(config => {
    return config.data
}, error => {
    if (error.response.status) {
        switch (error.response.status) {
            case 500:
                console.log(error);
                break
            case 401:
                Toast("登录过期，请重新登录")
                break
            default:
                console.log(error.response.data.message)
        }
    }
    return Promise.reject(error)
})

export default http
